/**
 * Log warnings when APIs return empty success responses
 * (e.g. user has no salon yet, no onboarding row). These are expected at
 * user-creation time but rare otherwise; we log for visibility.
 */

/**
 * Check if a value is an empty object (plain object with no keys).
 * Used to detect API responses that return {} instead of null/404.
 */
export function isEmptyObject(value: unknown): value is Record<string, never> {
  return (
    value !== null &&
    typeof value === "object" &&
    !Array.isArray(value) &&
    Object.keys(value as object).length === 0
  );
}

/**
 * Write a warning to the console when an API returns 200 with empty data
 * (no salon, no onboarding, etc.).
 */
export function recordApiEmptyResponseWarning(
  endpoint: string,
  message: string,
): void {
  const at = new Date().toISOString();
  console.warn(`[API_EMPTY_RESPONSE] ${endpoint}: ${message}`, {
    at,
    endpoint,
    message,
  });
}
